import React from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {Form as FormLayout} from "react-bootstrap";
import TextInput from "../../../../../Common/components/text-input";
import {formatFormTitle, FormikMultiFormSync} from "../../../../../../util/Helpers";

function TrustPerson(
    {
        dataKey,
        title,
        isEditable,
        initialValues: {
            trustData: {
                trustInfo = {}
            } = {}
        }
    }
) {
    const validationSchema = Yup.object({
        firstName: Yup.string().required('Required'),
        lastName: Yup.string().required('Required'),
        email: Yup.string().required('Required'),
        phone: Yup.string().required('Required'),
    })

    const compiledInitialValues = {
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        ...trustInfo
    }

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={compiledInitialValues}
                validateOnMount={true}
                enableReinitialize={true}
            >
                {({isValid}) =>
                    <Form>
                        <fieldset disabled={!isEditable}>
                            {formatFormTitle({title, isValid})}
                            <FormLayout.Row>
                                <TextInput
                                    label="First Name*"
                                    name="firstName"
                                    type="text"
                                />
                                <TextInput
                                    label="Last Name*"
                                    name="lastName"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormLayout.Row>
                                <TextInput
                                    label="Email*"
                                    name="email"
                                    type="email"
                                />
                                <TextInput
                                    label="Phone*"
                                    name="phone"
                                    type="text"
                                />
                            </FormLayout.Row>
                            <FormikMultiFormSync name={dataKey}/>
                        </fieldset>
                    </Form>
                }
            </Formik>
        </div>
    );
}

export default TrustPerson;